<template>
  <div class="form-edit-page">

    <!-- FILTROS -->
    <div class="form-card">
      <div class="form-title">Histórico de Ações e Acessos</div>

      <div class="row">
        <div class="form-item">
          <label>Processo</label>
          <input type="text" v-model="filtro.processo" placeholder="Código ou descrição"/>
        </div>

        <div class="form-item">
          <label>Usuário</label>
          <input type="text" v-model="filtro.usuario"/>
        </div>

        <div class="form-item">
          <label>Tipo</label>
          <select v-model="filtro.tipo">
            <option value="">Todos</option>
            <option value="ACESSO">Acesso</option>
            <option value="ACAO">Ação</option>
          </select>
        </div>

        <div class="form-item">
          <label>Período</label>
          <input type="date" v-model="filtro.dataInicio"/>
          <input type="date" v-model="filtro.dataFim"/>
        </div>

        <div class="form-item align-end">
          <button @click="filtrar">Pesquisar</button>
        </div>
      </div>
    </div>

    <!-- TIMELINE -->
    <div class="form-card">
      <div class="form-title">Linha do Tempo</div>

      <div class="timeline">
        <div v-for="(item, index) in dadosFiltrados" :key="index" class="timeline-item">
          
          <div class="timeline-dot" :class="item.tipo"></div>

          <div class="timeline-content">
            <div class="timeline-header">
              <strong>{{ item.acao }}</strong>
              <span class="timeline-data">{{ item.data }}</span>
            </div>

            <div class="timeline-body">
              <div><b>Usuário:</b> {{ item.usuario }}</div>
              <div><b>Processo:</b> {{ item.processo }}</div>
              <div><b>IP:</b> {{ item.ip }}</div>
              <div v-if="item.detalhe"><b>Detalhe:</b> {{ item.detalhe }}</div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- TABELA -->
    <div class="form-card">
      <div class="form-title">Registros Detalhados</div>

      <table class="table">
        <thead>
          <tr>
            <th>Data/Hora</th>
            <th>Tipo</th>
            <th>Usuário</th>
            <th>Ação</th>
            <th>Processo</th>
            <th>IP</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in dadosFiltrados" :key="index">
            <td>{{ item.data }}</td>
            <td>{{ item.tipo }}</td>
            <td>{{ item.usuario }}</td>
            <td>{{ item.acao }}</td>
            <td>{{ item.processo }}</td>
            <td>{{ item.ip }}</td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>

<script setup>
import { reactive, computed } from 'vue'

const filtro = reactive({
  processo: '',
  usuario: '',
  tipo: '',
  dataInicio: '',
  dataFim: ''
})

const dados = reactive([
  {
    data: '20/03/2026 09:10',
    tipo: 'ACESSO',
    usuario: 'João Silva',
    acao: 'Acessou o processo',
    processo: 'PROC-001',
    ip: '192.168.0.10'
  },
  {
    data: '20/03/2026 09:15',
    tipo: 'ACAO',
    usuario: 'João Silva',
    acao: 'Incluiu documento',
    processo: 'PROC-001',
    ip: '192.168.0.10',
    detalhe: 'Laudo técnico anexado'
  },
  {
    data: '20/03/2026 10:00',
    tipo: 'ACAO',
    usuario: 'Maria Souza',
    acao: 'Aprovou processo',
    processo: 'PROC-001',
    ip: '192.168.0.25'
  },
  {
    data: '20/03/2026 11:20',
    tipo: 'ACESSO',
    usuario: 'Carlos Lima',
    acao: 'Visualizou processo',
    processo: 'PROC-002',
    ip: '192.168.0.30'
  }
])

const dadosFiltrados = computed(() => {
  return dados.filter(d => {
    return (!filtro.processo || d.processo.includes(filtro.processo)) &&
           (!filtro.usuario || d.usuario.toLowerCase().includes(filtro.usuario.toLowerCase())) &&
           (!filtro.tipo || d.tipo === filtro.tipo)
  })
})

function filtrar() {
  // já está reativo via computed
}
</script>

<style scoped>
.timeline {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.timeline-item {
  display: flex;
  gap: 10px;
}

.timeline-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-top: 5px;
}

.timeline-dot.ACESSO {
  background-color: #3498db;
}

.timeline-dot.ACAO {
  background-color: #2ecc71;
}

.timeline-content {
  background: #f5f5f5;
  padding: 10px;
  border-radius: 6px;
  width: 100%;
}

.timeline-header {
  display: flex;
  justify-content: space-between;
}

.timeline-data {
  font-size: 12px;
  color: #777;
}
</style>